<div class="container mainContainer">
  <div class="title">{{ "survey.title" | translate }}</div>
  <div class="formContainer">
    @for (question of survey; track question; let i = $index) {
      <div
        class="questionContainer"
        >
        <div class="title">{{ question.question_content }}</div>
        @if (
          question.question_survey_type === SurveyQuestionType.onePick
          ) {
          <div
            class="onePickAnswersContainer"
            >
            @for (answer of question.possible_answers_survey; track answer) {
              <div
                class="answer"
                [class.active]="isActive(question, answer)"
                (click)="selectAnswerForQuestion(answer, question)"
                >
                {{ answer }}
              </div>
            }
          </div>
        }
        @if (
          question.question_survey_type ===
          SurveyQuestionType.threeOrderedPicks
          ) {
          <div
            class="threeOrderedPicksAnswersContainer"
            >
            @for (answer of question.possible_answers_survey; track answer) {
              <div
                class="answer"
                [class.active]="isActive(question, answer)"
                (click)="selectAnswerForQuestion(answer, question)"
                >
                {{ answer }}
              </div>
            }
          </div>
        }
        @if (
          question.question_survey_type ===
          SurveyQuestionType.openAnswer
          ) {
          <div
            class="openAnswerContainer"
            >
            <input
              type="text"
              [(ngModel)]="answers[i]"
                    placeholder="{{
                        'survey.typeHereInputPlaceholder' | translate
                    }}"
              />
          </div>
        }
      </div>
    }
    <div class="buttonContainer">
      <div
        (click)="sendAnswers()"
        class="button"
        [class.disabled]="!areAllAnswersOk()"
        >
        {{ "survey.sendButton" | translate }}
      </div>
    </div>
  </div>
</div>
